// import './Reminders.scss';
import * as React from 'react';
import { actionCreator as authActions } from '../../common/Auth0/store/actions/creators';
import { IApplicationState } from '../../store/ApplicationState';
import { Grid, CircularProgress, StyledComponentProps, withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { styles } from './styles';
import Paper from '../../ui-components/Containers/Paper';
import { WithMediaQuery, IMediaQueryProps } from '../../layout/withMediaQuery';
import { IState as ISubscriptionState } from '../../common/store/subscriptions/state';
import { IActions as ISubscriptionActions, actionCreator as subscriptionActions } from '../../common/store/subscriptions/actions/creators';
import { subscription, subscriptionRules } from '../../model/subscription';
import { SubscriptionList } from './List/SubscriptionList';
import { Subscription } from './Detail/Subscription';
import { Filters } from './Filter/Filters';

interface IProps extends ISubscriptionActions, ISubscriptionState, IMediaQueryProps, StyledComponentProps {
    // navigateTo: (path: string) => void;
    // match: {
    //     params: {
    //         id: string
    //     }
    // }
}
interface IState {
    textSearch: string;
    // selectedSubscription: subscription;
}

class CompContainer extends React.Component<IProps, IState>
{
    state = {
        textSearch: "",
        // selectedSubscription: undefined, // emptySubscription(),
    };
    componentDidMount() {
        this.props.searchSubscriptions();
    }
    handleSelection = (_id: string) => {
        this.props.loadSubscription(_id);
        // this.setState({
        //     selectedSubscription: this.props.selectedSubscription
        // })
    }
    search = (textSearch?: string, subscriptionType?: any, subscriptionState?: string) => {
        // console.log("------------------------------------search----");
        // console.log(subscriptionType);
        // console.log(subscriptionState);
        this.props.searchSubscriptions(textSearch, subscriptionType, subscriptionState);
    }
    handleFilterChange = (val: string) => {
        this.setState({ textSearch: val });
    }
    // onNewSubscriptionClick = () => {
    //     // var s = emptySubscription();
    //     // 
    //     // 
    //     // console.log(this.state.selectedSubscription);
    //     // this.setState({
    //     //     selectedSubscription: emptySubscription()
    //     // })
    // }
    saveSubscription = (s: subscription, rules: subscriptionRules) => {
        s.subscriptionRules = rules;
        if (s._id === '') {
            this.props.addSubscription(s);
        } else {
            this.props.saveSubscription(s);
        }
    }

    render() {
        // const { id } = this.props.match.params;
        // const { classes } = this.props;
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Filters
                        handleFilterChange={this.handleFilterChange}
                        search={this.search}
                        textSearch={this.state.textSearch}
                        classes={this.props.classes}
                        new={this.props.newSubscription}
                        loading={this.props.isLoading}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Paper title='Elenco'
                        collapsed={this.props.smallScreen ? true : false} 
                        fullHeight={false}
                        contentContainerStyle={this.props.smallScreen ? { minHeight: '300px' } : { heigth: 'calc(100% - 1px)' }}>
                        <Grid container>
                            {this.props.isLoading ? 
                                <Grid container justify={"center"} style={{ display: 'flex' }}>
                                    <CircularProgress size={80} />
                                </Grid>
                                :
                                <>
                                <Grid item xs={12} >
                                    <SubscriptionList
                                        classes={this.props.classes}
                                        subscriptionList={this.props.subscriptions}
                                        selectedId={this.props.selectedSubscription?._id}
                                        onSubscriptionClick={this.handleSelection}
                                        // doneReminder={this.doneReminder}
                                        // navigateTo={this.props.navigateTo}
                                    />
                                </Grid>
                                </>
                            }
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={6}>
                    {/* {true ? : <></>} */}
                    <Paper title='Dati' fullHeight contentContainerStyle={{ padding: 8 }} id="SubscriptionData">
                        <Grid container spacing={1}>
                            {/* {console.log("-----------------------------------------------s-s-s-s-s--------")}
                            {console.log(this.props.selectedSubscription)} */}
                            { this.props.isLoading || this.props.isLoadingSubscriptions ? 
                                <Grid container justify={"center"} style={{ display: 'flex' }}>
                                    <CircularProgress size={80} />
                                </Grid>
                                : 
                                <Grid item xs={12}>
                                    <Subscription
                                        classes={this.props.classes}
                                        subscription={this.props.selectedSubscription}
                                        isLoading={this.props.isLoadingSubscriptions}
                                        saveSubscription={(t, rules) => this.saveSubscription(t, rules)}
                                        // trainer={this.props.selectedTrainer}
                                        // tags={this.props.tags}
                                    />
                                </Grid>
                                }
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state: IApplicationState, ownP) => ({
    ...state.subscriptions,
    ...ownP
})

const mapDispatchToProps = (dispatch: any) => ({
    ...subscriptionActions(dispatch),
    navigateTo: authActions(dispatch).navigateTo
})

export const Subscriptions = connect(mapStateToProps, mapDispatchToProps)(WithMediaQuery(withStyles(styles)(CompContainer)));